interface ArticleJsonLdProps {
  headline: string;
  description: string;
  path: string;
  datePublished: string;
  imageUrl: string;
}

export default function ArticleJsonLd({
  headline,
  description,
  path,
  datePublished,
  imageUrl,
}: ArticleJsonLdProps) {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://mulebuyspreadsheets.boats';
  const url = `${siteUrl}${path}`;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    description,
    url,
    datePublished,
    dateModified: '2026-06-22',
    author: {
      '@type': 'Organization',
      name: 'Mulebuy Editorial Team',
      url: siteUrl,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Mulebuy Spreadsheet',
      url: siteUrl,
    },
    image: imageUrl,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}